export const nav = {
    p1: `Puoi gestire le tue informazioni personali, cambiare la password, le integrazioni, l'abbonamento e regolare le preferenze utente`,
    p2: `Il mio account`,
    p3: `Personalizza i dettagli del tuo alloggio, personalizza i messaggi di benvenuto, le politiche, collegati con le autorità locali per l'invio automatico delle comunicazioni degli alloggiati e regola le preferenze operative`,
    p4: `Impostazioni dell'alloggio`,
    p5: `Gestisci e promuovi i servizi aggiuntivi del tuo alloggio, come l'affitto di spazi, tour e altri extra, per migliorare l'esperienza dei tuoi ospiti e aumentare i tuoi ricavi`,
    p6: `Vendite incrociate`,
    p7: `Crea nuovo alloggio`,
    p8: `Email di conferma inviata con successo`,
    p9: `Alloggi`,
    p10: ``,
    p11: ``,
    p12: ``,
    p13: ``,
    p14: ``,
    p15: ``,
    p16: ``,
    p17: ``,
    p18: ``,
    p19: ``,
    p20: ``,
    p21: ``,
    p22: ``,
    p23: ``,
};
